import type { CSSProperties, ReactNode } from "react";

const marqueeStyle: CSSProperties = {
  animation: "marquee 12s linear infinite",
};

const keyframes = `
@keyframes marquee {
  0% { transform: translateX(0%); }
  100% { transform: translateX(-50%); }
}
`;

interface MarqueeProps {
  children: ReactNode;
}

export const Marquee = ({ children }: MarqueeProps) => (
  <div className="w-full overflow-hidden py-2">
    <style>{keyframes}</style>
    <div className="flex gap-12 whitespace-nowrap" style={marqueeStyle}>
      {children}
      {children}
      {children}
      {children}
    </div>
  </div>
);
